/**
 * 日付周りの操作を行うUtilクラス。
 */
export default class DateUtil {
	/**
	 * 日付形式の日付文字列を`YYYY.M.D H:MM`に変換する。
	 * 日付形式でない文字列が渡された場合、その文字列をそのまま返却する。
	 * @param input 対象日付
	 * @returns 変換後の日付
	 */
	public static convertDiplayFormat(input: string): string {
		// 空文字の場合そのまま返却
		if (!input) {
			return input;
		}
		// 日付形式ではない場合そのまま返却
		const inputDate = new Date(input);
		if (this.isInvalidDate(inputDate)) {
			return input;
		}
		const dateSeparateStr = ".";
		const timeSeparateStr = ":";
		const yyyymd = `${inputDate.getFullYear()}${dateSeparateStr}${inputDate.getMonth() + 1}${dateSeparateStr}${inputDate.getDate()}`;
		const hmm = `${inputDate.getHours()}${timeSeparateStr}${("00" + inputDate.getMinutes()).slice(-2)}`;
		return `${yyyymd} ${hmm}`;
	}

	/**
	 * 日付のオブジェクトが日付オブジェクトであることを判定する。
	 * @param date 対象となる日付オブジェクト。
	 * @returns `true`:日付オブジェクトである/`false`日付オブジェクトでない
	 */
	public static isInvalidDate(date: Date): boolean {
		return date.toString() === "Invalid Date";
	}
}
